import layer1 from '../../assets/login_page/layer1.svg';
import layer2 from '../../assets/login_page/layer2.svg';
import layer3 from '../../assets/login_page/layer3.svg';
import './styles.css';

const HomeImage = () => {
  return (
    <div
      data-testid="home-image"
      className="home-image-container"
      style={{ position: 'relative' }}
    >
      <img
        src={layer1}
        alt="layer1"
        style={{ width: '100%', position: 'absolute', '--translateY': '50px' }}
      />
      <img
        src={layer2}
        alt="layer1"
        style={{ width: '100%', position: 'absolute', '--translateY': '80px' }}
      />
      <img
        src={layer3}
        alt="layer1"
        style={{
          width: '100%',
          position: 'absolute',
          '--translateY': '20px',
          '--translateX': '100px',
        }}
      />
    </div>
  );
};

export default HomeImage;
